const source = {
  en: {
    source: {
      title: "Title",
      first_name: "First Name",
      last_name: "Last Name",
      job_title: "Job Title",
      affiliation: "Affiliation",
      category: "Category",
      associated_articles: "Articles Count",
      include_unused_source: 'Include unused sources',
      actions: {
        merge: "Merge",
        export: "Export",
        edit: "Edit",
        delete: "Delete"
      },
      tooltips: {
        unused_source: 'Use the toggle to reveal unused sources.',
        unused_source_disabled: "Select a date range to activate button."
      },
      table: {
        last_article: 'Last Article'
      }
    },
    merge_source: {
      merge: "Merge Sources",
      merge_message: "The merge will combine multiple sources into one unified source. All articles in the selected sources will move to the unified source.",
      merge_action: "Merge"
    }
  }
}

module.exports.source = source;